import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header-menu" }
const _hoisted_2 = { class: "header-menu__body" }

import MenuItem from '@/components/menu/MenuItem.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderMenu',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(MenuItem, {
        title: "Приём",
        to: { name: 'receiving' }
      }),
      _createVNode(MenuItem, {
        title: "Должники",
        to: { name: 'debtors' }
      }),
      _createVNode(MenuItem, {
        title: "Оплаты",
        to: { name: 'payments' }
      })
    ])
  ]))
}
}

})